import axiosInstance from "../../../helpers/api";

export const getAllRequests = (body) => {
  return axiosInstance.get("/superadmin/video-requests/pending", body);
};

export const editRequests = (formData) => {
  return axiosInstance.post(`/superadmin/video-requests/accept`, formData);
};

export const acceptRequestWithoutVoucher = (body) => {
  return axiosInstance.post(`/superadmin/video-requests/accept`, body);
};

export const deleteRequest = (body) => {
  return axiosInstance.post(`/superadmin/video-requests/reject`, body);
};
